/**
 * App Component
 *
 * Root component of the application
 */

import { ToastProvider, DialogProvider } from '@medsuite/ui-components';
import React from 'react';
import { Outlet } from 'react-router-dom';

import { AIAssistantButton, AIAssistantPanel } from './components/AIAssistant';
import { Header } from './components/Header/Header';
import { useAIChat } from './hooks/useAIChat';
import { useInvestmentContext } from './hooks/useInvestmentContext';
import { DigestNotificationProvider } from './providers/DigestNotificationProvider';

function App() {
  // AI Assistant hooks
  const aiChat = useAIChat();
  const investmentContext = useInvestmentContext();

  try {
    return (
      <ToastProvider>
        <DialogProvider>
          <DigestNotificationProvider>
          <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
            <Header />

            <main>
              <Outlet />
            </main>

            <footer className="bg-white dark:bg-gray-800">
              <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
                <p className="text-center text-sm text-gray-500 dark:text-gray-400">
                  &copy; {new Date().getFullYear()} MedSuite. All rights reserved.
                </p>
              </div>
            </footer>

            {/* AI Assistant */}
            <AIAssistantButton isOpen={aiChat.isOpen} onClick={aiChat.togglePanel} />
            <AIAssistantPanel chat={aiChat} investmentContext={investmentContext} />
          </div>
          </DigestNotificationProvider>
        </DialogProvider>
      </ToastProvider>
    );
  } catch (error) {
    console.error('Error in App component:', error);
    return (
      <div style={{ padding: '20px', fontFamily: 'monospace' }}>
        <h1 style={{ color: 'red' }}>App Component Error</h1>
        <p>{error instanceof Error ? error.message : 'Unknown error'}</p>
      </div>
    );
  }
}

export default App;
